/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_Inventory_HoldInputs */

const en_release_inventory_hold = /** @type {(inputs: Release_Inventory_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Inventory Hold`)
};

const es_release_inventory_hold = /** @type {(inputs: Release_Inventory_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberar apartado de inventario`)
};

/**
* | output |
* | --- |
* | "Release Inventory Hold" |
*
* @param {Release_Inventory_HoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const release_inventory_hold = /** @type {((inputs?: Release_Inventory_HoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Inventory_HoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_release_inventory_hold(inputs)
	return es_release_inventory_hold(inputs)
});